<script lang="ts" setup>
defineOptions({
  name: 'OpenSummit',
});
</script>

<template>
  <section class="mx-auto w-1200px flex justify-between pt-128px">
    <div>
      <h1 class="h-47px text-32px text-#00479D font-medium leading-45px">开放原子全球开源峰会</h1>
      <h2 class="h-21px text-14px text-#00479D font-normal leading-20px tracking-0.5px">OPENATOM GLOBAL OPENSOURCE SUMMIT</h2>
      <div class="w-560px pt-30px text-16px text-#2D2D2D font-normal leading-24px">
        开放原子全球开源峰会是开放原子开源基金会本着以开发者为本的开源项目孵化平台、科技公益性服务机构的定位，立足中国，面向世界发起的大会，峰会依托国际化平台，聚集政、产、学、研、用、创、投、金等各领域的优势资源，共商开源发展大计，共筑开源发展未来，凝聚共建、共治、共享的发展共识！
      </div>
    </div>
    <img src="https://res.oafimg.cn/-/7891e29f66ed7fd9/OAGS2023.jpg" class="h-196px object-fill">
  </section>
</template>

<style lang="scss" scoped>
</style>
